<template>
  <p class="clearfix mb-0 d-flex justify-content-center">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      Copyright © {{ new Date().getFullYear() + ' - ' + t('All Rights Reserved') }}
    </span>
  </p>
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';

export default {
  setup() {
    const { t } = useI18nUtils();
    return {
      t
    };
  }
};
</script>
